import { emailTemplateSchema } from "@redotech/redo-marketing-templates-common/email-template";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getEmailTemplate = {
  name: "getEmailTemplate" as const,
  input: z.union([
    z.object({ id: zExt.objectId() }),
    z.object({ originTemplateId: zExt.objectId() }),
  ]),
  output: emailTemplateSchema.extend({ isOrigin: z.boolean().optional() }),
};
